import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { useLocation } from 'react-router-dom';

type HistoryValue = {
  removeLastTwoLinks: () => void;
  removePerticulerLink: (link: string) => void
  backLink?: string;
  pushNewHistoryItem: (link: string) => void
  pushNewLinks: (links: string[]) => void
};

const historyStubValue = { removeLastTwoLinks: () => new Error(), removePerticulerLink: (link: string) => new Error(), pushNewLinks: (links: string[]) => new Error(), pushNewHistoryItem: (link: string) => new Error(), backLink: undefined };

export const HistoryContext = React.createContext<HistoryValue>(historyStubValue);

export const HistoryProvider = ({ ...props }) => {
  const [history, setHistory] = useState<string[]>([]);
  const [force, setForce] = useState<boolean>(false)
  const { pathname, search } = useLocation();
  let urlPath = pathname + search

  const pushNewHistoryItem = useCallback(
    (link: string) => {
      const newHistory = [...history.filter(i => i !== link), link];
      setHistory(newHistory);
    },
    [history],
  );

  const removeLastTwoLinks = () => {
    setForce(false)
    const newHistory = history.slice(0, -2);
    setHistory(newHistory);
  };
  const removePerticulerLink = (link: string) => {
    setForce(false)
    setHistory(history.filter(i => i !== link));
  }

  const pushNewLinks = (links: string[]) => {
    setForce(true)
    setTimeout(() => setForce(false), 1000)
    const newHistory = [...history.filter(i => !links.includes(i)), ...links];
    setHistory(newHistory);
  }

  useEffect(() => {
    if (!force && urlPath !== history[history.length - 1]) {
      pushNewHistoryItem(urlPath);
    }
  }, [history, urlPath, pushNewHistoryItem]);

  const backLink = useMemo(() => history[history.length - 2], [history]);
  return <HistoryContext.Provider {...props} value={{ removeLastTwoLinks, removePerticulerLink, pushNewHistoryItem, pushNewLinks, backLink }} />;
};
